import { render, staticRenderFns } from "./TransactionProfileLink.vue?vue&type=template&id=13860062&"
import script from "./TransactionProfileLink.vue?vue&type=script&lang=ts&"
export * from "./TransactionProfileLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports